import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export interface DiscoveryNoticeState {
  messageKey: string
  tone: 'success' | 'error'
}

interface DiscoveryNoticeProps {
  notice: DiscoveryNoticeState | null
  onDismiss: () => void
}

export function DiscoveryNotice({ notice, onDismiss }: DiscoveryNoticeProps) {
  const { t } = useTranslation()

  useEffect(() => {
    if (!notice) return
    const timer = window.setTimeout(onDismiss, 4500)
    return () => window.clearTimeout(timer)
  }, [notice, onDismiss])

  if (!notice) return null

  return (
    <div
      role={notice.tone === 'error' ? 'alert' : 'status'}
      aria-live={notice.tone === 'error' ? 'assertive' : 'polite'}
      className={`fixed inset-x-4 bottom-[calc(var(--bottom-nav-height)+var(--safe-bottom)+16px)] z-50 mx-auto max-w-md rounded-md px-4 py-3 text-sm font-semibold shadow-[var(--shadow-float)] md:right-8 md:bottom-8 md:left-auto md:mx-0 ${
        notice.tone === 'error'
          ? 'bg-danger-soft text-danger'
          : 'bg-deep text-paper'
      }`}
    >
      {t(notice.messageKey)}
    </div>
  )
}
